import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { DOCUMENT, isPlatformServer } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/core';
import { buildDynamicImageUrl } from '../_utils/image-resolver-url';

const META_TAGS_KEY = makeStateKey<{ogImage: string}>('metaTags');

@Injectable({
  providedIn: 'root'
})
export class MetaTagsManagementService {
  constructor(
    private meta: Meta, 
    private title: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferState: TransferState,
    @Inject(DOCUMENT) private document: Document
  ) {}

  updateDescription(description: string): void {
    this.meta.updateTag({ 
      name: 'description', 
      content: description 
    });
    
    this.meta.updateTag({ 
      name: 'Description', 
      content: description 
    });
  }


  updateMetaTags(tags: { [key: string]: string }): void {
    if (tags['description']) {
      this.updateDescription(tags['description']);
    }

    Object.keys(tags).forEach(key => {
      if (key !== 'description') {
        this.meta.updateTag({ name: key, content: tags[key] });
      }
    });
  }

  updateTitle(title: string): void {
    this.title.setTitle(title);
  }

  setSeoData(config: {
    title: string;
    description: string;
  }): void {
    this.updateTitle(config.title);
    this.updateDescription(config.description);

    const { title, description, ...metaTags } = config;
    this.updateMetaTags(metaTags);
  }

  updateOgImage_old(imageUrl: string): void {
    this.meta.updateTag({ 
      property: 'og:image',
      content: imageUrl 
    });
    
    this.meta.updateTag({ 
      name: 'og:image',
      content: imageUrl 
    });
  }

  updateOgImage(imageUrl: string): void {
    this.meta.addTag({ 
      property: 'og:image',
      content: imageUrl 
    });

    this.meta.addTag({ 
      property: 'og:image:type',
      content: 'image/jpeg' 
    });
    
  }


  updateDynamicImage(params: {
    imgVersion: string;
    firstName: string;
    address: string;
    imgResolver?: string;
  }): void {
    const imageUrl = buildDynamicImageUrl(params, params.imgResolver);
    
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(META_TAGS_KEY, { ogImage: imageUrl });
      
      this.updateMetaTagsDirectly(imageUrl);
    } else {
      this.updateClientMetaTags(imageUrl);
    }
  }

  private updateMetaTagsDirectly(imageUrl: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    
    const existingOgImage = this.document.querySelector('meta[property="og:image"]');
    if (existingOgImage) {
      existingOgImage.setAttribute('content', imageUrl);
    } else {
      const ogImageMeta = this.document.createElement('meta');
      ogImageMeta.setAttribute('property', 'og:image');
      ogImageMeta.setAttribute('content', imageUrl);
      head.appendChild(ogImageMeta);
    }

    const existingOgImageType = this.document.querySelector('meta[property="og:image:type"]');
    if (existingOgImageType) {
      existingOgImageType.setAttribute('content', 'image/jpeg');
    } else {
      const ogImageTypeMeta = this.document.createElement('meta');
      ogImageTypeMeta.setAttribute('property', 'og:image:type');
      ogImageTypeMeta.setAttribute('content', 'image/jpeg');
      head.appendChild(ogImageTypeMeta);
    }
  }

  updateClientMetaTags(imageUrl: string): void {
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({ property: 'og:image:type', content: 'image/jpeg' });
  }

  getDynamicImageUrl(): string | null {
    const metaTags = this.transferState.get(META_TAGS_KEY, null);
    return metaTags?.ogImage || null;
  }

}
